import { BusinessCategory, BusinessSize } from '@sdk/authentication/types';
import { BUSINESS_SIZE } from '@sdk/authentication/constants';

const restaurantIndustry = [
  BusinessCategory.bar,
  BusinessCategory.cafe,
  BusinessCategory.catering,
  BusinessCategory.coffeeShop,
  BusinessCategory.foodTruck,
  BusinessCategory.hotel,
  BusinessCategory.restaurant,
];

export const doesBusinessMatchChiliPiper = (
  businessCategory: BusinessCategory,
  businessSize: BusinessSize
): boolean => {
  if (restaurantIndustry.includes(businessCategory)) {
    return true;
  }

  const sizeIndex = BUSINESS_SIZE.indexOf(businessSize);

  return sizeIndex >= 1; // 21+ employees
};
